import { LoginForm } from "./login.form";

export const LoginPage = () => {
  return <LoginForm />;
};
